import React from 'react';
import { motion } from 'framer-motion';
import ReactDOM from 'react-dom';

function Slide(props) {
	const { children, toggle } = props;

	return (
		<>
			{toggle &&
				ReactDOM.createPortal(<motion.div initial={{y: '100%'}} transition={{ duration: 0.5, ease: 'easeInOut'}} className="o-hidden d-none d-block--xs z-20 p-fixed t-0 w-100p h-100p l-0" animate={{ y: ['100%','0%'] }}>{children}</motion.div>, document.body)}
		</>
	);
}

export default Slide;
